const initialState = {
    stepName: null,
    closeTimeout: null,
};
export const troubleshootingReducer = (state = initialState, action = {}) => {
    const { type, payload } = action;
    switch (type) {
        case 'TROUBLESHOOTING/SET_STEP_NAME':
            return { ...state, stepName: payload };
        case 'TROUBLESHOOTING/SET_CLOSE_TIMEOUT':
            return { ...state, closeTimeout: payload };
        default:
            return state;
    }
};
export default troubleshootingReducer;
